import { render, staticRenderFns } from "./cModalRegPatient.vue?vue&type=template&id=58eaa4de&scoped=true"
import script from "./cModalRegPatient.vue?vue&type=script&lang=js"
export * from "./cModalRegPatient.vue?vue&type=script&lang=js"
import style0 from "./cModalRegPatient.vue?vue&type=style&index=0&id=58eaa4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eaa4de",
  null
  
)

export default component.exports